<div class="row">
  <div class="col">
    <sb-card>
      <div card-header>
        <h3>{{'lang.globals.overview' | translate}}</h3>
      </div>
      <div card-body>
        <form [formGroup]="form" class="wizard__forms px-5 pb-5">
          <h3 class="mb-4">{{'lang.user.personalData' | translate}}</h3>
          <div class="row">
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="FirstName">{{'lang.user.firstname' | translate}}</label>
                <input type="text" id="FirstName" class="form-control" formControlName="FirstName">
                <div *ngIf="FirstName.touched && FirstName.errors?.required" class="alert alert-danger">
                  {{'lang.user.firstnameWarning' | translate}}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="LastName">{{'lang.user.lastname' | translate}}</label>
                <input type="text" id="LastName" class="form-control" formControlName="LastName">
                <div *ngIf="LastName.touched && LastName.errors?.required" class="alert alert-danger">
                  {{'lang.user.lastnameWarning' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="Email">{{'lang.user.email' | translate}}</label>
                <input type="text" id="Email" class="form-control" formControlName="Email">
                <div *ngIf="Email.touched && Email.errors?.required" class="alert alert-danger">
                  {{'lang.user.emailWarning' | translate}}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="UserName">{{'lang.login.username' | translate}}</label>
                <input type="text" id="UserName" class="form-control" formControlName="UserName">
                <div *ngIf="UserName.touched && UserName.errors?.required" class="alert alert-danger">
                  {{'lang.login.usernameWarning' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group d-block">
                <label class="form-label" for="PrimaryClient">{{'lang.user.primaryClient' | translate}}</label>
                <button (click)="clientModal()" type="button" id="PrimaryClient"
                        class="btn btn-secondary w-100 text-center">
                  <sb-icon class="mr-1" icon="companyClient"></sb-icon>
                  {{primaryClient ? primaryClient?.name : ('lang.globals.default'|translate)}}
                </button>
              </div>
            </div>
          </div>
          <hr class="border-dashed">
          <div class="row">
            <div class="col text-end">
              <sb-button
                (click)="submit()" [disabled]="formInvalid"
                classes="btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</sb-button>
            </div>
          </div>
        </form>
      </div>
    </sb-card>
  </div>
</div>
